<div *ngIf="patientDetails!==undefined">
    <app-day *ngIf="currentFilter=='daily'" [showSpecificPatient]="showSpecificPatient"></app-day>
    <app-week *ngIf="currentFilter=='weekly'" [showSpecificPatient]="showSpecificPatient"></app-week>
    <app-month *ngIf="currentFilter=='monthly'" [showSpecificPatient]="showSpecificPatient"></app-month>
</div>

<!-- <app-week (onChange)="sharedVar = $event.value"></app-week> -->